export const createEmptyBanquet = () => ({
  id: "",
  slug: "",
  title: "",
  name: "",
  ownerId: "",
  ownerEmail: "",
  assignedUserIds: [],
  assignedUserEmails: [],
  managerEmails: [],
  staffEmails: [],
  phone: "",
  whatsappNumber: "",
  email: "",
  basicDetails: {
    banquetName: "",
    venueTypes: [],
  },
  contactDetails: {
    contactPerson: "",
    mobileNumber: "",
    alternateMobile: "",
    whatsappNumber: "",
    sameAsMobile: false,
    email: "",
    website: "",
    instagram: "",
    facebook: "",
    youtube: "",
  },
  locationDetails: {
    city: "",
    locality: "",
    fullAddress: "",
    landmark: "",
    pincode: "",
    googleMapLink: "",
    latitude: null,
    longitude: null,
  },
  capacityDetails: {
    seatingCapacity: null,
    floatingCapacity: null,
    minimumGuestRange: "",
    halls: [],
    roomsAvailable: false,
    numberOfRooms: null,
    complimentaryRoomAvailable: false,
    numberOfComplimentaryRooms: null,
    bridalRoomAvailable: false,
    numberOfBridalRooms: null,
    liftAvailable: false,
    passengerLiftCount: null,
    serviceLiftAvailable: false,
    wheelchairAccessible: false,
  },
  pricingDetails: {
    pricingModels: [],
    foodType: "",
    vegStartingFrom: null,
    nonVegStartingFrom: null,
    hallRentalStartingFrom: null,
    farmhouseRentalStartingFrom: null,
    bookingAdvanceRequired: "",
  },
  foodCatering: {},
  decorationServices: {},
  alcoholPolicy: {},
  timingDetails: {},
  parkingDetails: {},
  media: {
    coverPhotos: [],
    galleryPhotos: [],
    videoTeasers: [],
    droneVideos: [],
    tour360: { video: null, link: "" },
    socialVideoLinks: [],
    mediaHighlights: [],
    primaryCoverIndex: 0,
  },
  highlights: [],
  packagesMenu: [],
  coverImage: "",
  coverImageMeta: null,
  images: [],
  imageMetaByUrl: {},
  teaserVideoUrl: "",
  teaserVideoMeta: null,
  pricing: {
    vegPrice: null,
    nonVegPrice: null,
    currency: "INR",
  },
  address: {
    line1: "",
    line2: "",
    pincode: "",
    latitude: null,
    longitude: null,
  },
  pincode: "",
  locality: "",
  area: "",
  city: "",
  shortDescription: "",
  description: "",
  guestRange: {
    min: null,
    max: null,
  },
  guestMin: null,
  guestMax: null,
  vegPrice: null,
  nonVegPrice: null,
  googleRating: null,
  googleRatingsTotal: null,
  googlePlaceId: "",
  website: "",
  openingHours: [],
  googlePhotos: [],
  venueType: "",
  featured: false,
  mapUrl: "",
  googleMapsUrl: "",
  googleMapsEmbedUrl: "",
  latitude: null,
  longitude: null,
  facilities: [],
  tags: [],
  eventTypes: [],
  goodFor: [],
  notIdealFor: [],
  indoorOutdoor: [],
  foodType: "",
  floors: "",
  parkingAvailable: false,
  parkingCapacity: 0,
  valetParking: false,
  roomsAvailable: false,
  roomCount: 0,
  bridalRoom: false,
  changingRoom: false,
  acHall: false,
  powerBackup: false,
  lift: false,
  wheelchairFriendly: false,
  liquorAllowed: false,
  byobAllowed: false,
  djAllowed: false,
  lateNightAllowed: false,
  decorPolicy: "",
  cateringPolicy: "",
  alcoholPolicyText: "",
  outsideCateringAllowed: false,
  outsideCateringPolicy: "",
  bookingPolicy: "",
  cancellationPolicy: "",
  paymentTerms: "",
  policies: {
    decorPolicy: "",
    cateringPolicy: "",
    liquorPolicy: "",
    djPolicy: "",
    lateNightPolicy: "",
  },
  availabilityCalendar: {
    timezone: "Asia/Kolkata",
    lastSyncedAt: null,
    unavailableDates: [],
    bookedSlots: {},
    slotAvailability: {
      lunch: true,
      dinner: true,
    },
  },
  bookedSlots: {},
  bookedDates: {},
  status: "draft",
  submittedForApproval: false,
  submittedAt: null,
  approvedAt: null,
  rejectedAt: null,
  approvedBy: "",
  rejectionReason: "",
  hasPendingEdit: false,
  pendingEditBy: "",
  pendingEditSubmittedAt: null,
  pendingEditRejectionReason: "",
  ownerName: "",
  createdByOwner: false,
  createdBy: "",
  isActive: true,
  // Defaults to false (not locked) so every EXISTING banquet that predates this field keeps
  // behaving exactly as it always has — this default only matters for docs missing the key
  // entirely. New owner/manager accounts are explicitly locked at creation time instead (see
  // createBanquetOwnerAccount in functions/index.js and buildDraftBanquetForOwner below),
  // rather than via this shared default, precisely so this line can never retroactively lock
  // an already-active owner's dashboard.
  detailsLocked: false,
  createdAt: null,
  updatedAt: null,
});

export const normalizeBanquet = (banquet = {}) => {
  const base = createEmptyBanquet();

  return {
    ...base,
    ...banquet,
    id: banquet.id || base.id,
    slug: banquet.slug || base.slug,
    title: banquet.title || banquet.name || base.title,
    name: banquet.name || banquet.title || base.name,
    ownerId: banquet.ownerId || base.ownerId,
    ownerEmail: banquet.ownerEmail || base.ownerEmail,
    assignedUserIds: Array.isArray(banquet.assignedUserIds) ? banquet.assignedUserIds : base.assignedUserIds,
    assignedUserEmails: Array.isArray(banquet.assignedUserEmails) ? banquet.assignedUserEmails : base.assignedUserEmails,
    managerEmails: Array.isArray(banquet.managerEmails) ? banquet.managerEmails : base.managerEmails,
    staffEmails: Array.isArray(banquet.staffEmails) ? banquet.staffEmails : base.staffEmails,
    phone: banquet.phone || base.phone,
    whatsappNumber: banquet.whatsappNumber || base.whatsappNumber,
    email: banquet.email || base.email,
    basicDetails: {
      ...base.basicDetails,
      ...(banquet.basicDetails || {}),
      banquetName: banquet.basicDetails?.banquetName || banquet.name || banquet.title || base.basicDetails.banquetName,
      venueTypes: Array.isArray(banquet.basicDetails?.venueTypes)
        ? banquet.basicDetails.venueTypes
        : banquet.venueType
          ? [banquet.venueType]
          : base.basicDetails.venueTypes,
    },
    contactDetails: {
      ...base.contactDetails,
      ...(banquet.contactDetails || {}),
      mobileNumber: banquet.contactDetails?.mobileNumber || banquet.phone || base.contactDetails.mobileNumber,
      whatsappNumber: banquet.contactDetails?.whatsappNumber || banquet.whatsappNumber || base.contactDetails.whatsappNumber,
      email: banquet.contactDetails?.email || banquet.email || base.contactDetails.email,
      website: banquet.contactDetails?.website || banquet.website || base.contactDetails.website,
    },
    locationDetails: {
      ...base.locationDetails,
      ...(banquet.locationDetails || {}),
      city: banquet.locationDetails?.city || banquet.city || base.locationDetails.city,
      locality: banquet.locationDetails?.locality || banquet.locality || base.locationDetails.locality,
      fullAddress:
        banquet.locationDetails?.fullAddress ||
        (typeof banquet.address === "string" ? banquet.address : banquet.address?.line1) ||
        base.locationDetails.fullAddress,
      pincode: banquet.locationDetails?.pincode || banquet.pincode || banquet.address?.pincode || base.locationDetails.pincode,
      googleMapLink: banquet.locationDetails?.googleMapLink || banquet.googleMapsUrl || banquet.mapUrl || base.locationDetails.googleMapLink,
      latitude: banquet.locationDetails?.latitude ?? banquet.latitude ?? banquet.address?.latitude ?? base.locationDetails.latitude,
      longitude: banquet.locationDetails?.longitude ?? banquet.longitude ?? banquet.address?.longitude ?? base.locationDetails.longitude,
    },
    capacityDetails: {
      ...base.capacityDetails,
      ...(banquet.capacityDetails || {}),
      seatingCapacity: banquet.capacityDetails?.seatingCapacity ?? banquet.guestMin ?? banquet.capacity ?? base.capacityDetails.seatingCapacity,
      floatingCapacity: banquet.capacityDetails?.floatingCapacity ?? banquet.guestMax ?? base.capacityDetails.floatingCapacity,
      roomsAvailable:
        typeof banquet.capacityDetails?.roomsAvailable === "boolean"
          ? banquet.capacityDetails.roomsAvailable
          : typeof banquet.roomsAvailable === "boolean"
            ? banquet.roomsAvailable
            : base.capacityDetails.roomsAvailable,
      numberOfRooms: banquet.capacityDetails?.numberOfRooms ?? banquet.roomCount ?? base.capacityDetails.numberOfRooms,
      bridalRoomAvailable:
        typeof banquet.capacityDetails?.bridalRoomAvailable === "boolean"
          ? banquet.capacityDetails.bridalRoomAvailable
          : typeof banquet.bridalRoom === "boolean"
            ? banquet.bridalRoom
            : base.capacityDetails.bridalRoomAvailable,
      liftAvailable:
        typeof banquet.capacityDetails?.liftAvailable === "boolean"
          ? banquet.capacityDetails.liftAvailable
          : typeof banquet.lift === "boolean"
            ? banquet.lift
            : base.capacityDetails.liftAvailable,
      wheelchairAccessible:
        typeof banquet.capacityDetails?.wheelchairAccessible === "boolean"
          ? banquet.capacityDetails.wheelchairAccessible
          : typeof banquet.wheelchairFriendly === "boolean"
            ? banquet.wheelchairFriendly
            : base.capacityDetails.wheelchairAccessible,
    },
    pricingDetails: {
      ...base.pricingDetails,
      ...(banquet.pricingDetails || {}),
      foodType: banquet.pricingDetails?.foodType || banquet.foodType || base.pricingDetails.foodType,
      vegStartingFrom: banquet.pricingDetails?.vegStartingFrom ?? banquet.vegPrice ?? banquet.pricing?.vegPrice ?? base.pricingDetails.vegStartingFrom,
      nonVegStartingFrom:
        banquet.pricingDetails?.nonVegStartingFrom ?? banquet.nonVegPrice ?? banquet.pricing?.nonVegPrice ?? base.pricingDetails.nonVegStartingFrom,
    },
    coverImage: banquet.coverImage || base.coverImage,
    coverImageMeta: banquet.coverImageMeta || base.coverImageMeta,
    images: Array.isArray(banquet.images) ? banquet.images : base.images,
    imageMetaByUrl:
      banquet.imageMetaByUrl && typeof banquet.imageMetaByUrl === "object" && !Array.isArray(banquet.imageMetaByUrl)
        ? banquet.imageMetaByUrl
        : base.imageMetaByUrl,
    teaserVideoUrl: banquet.teaserVideoUrl || base.teaserVideoUrl,
    teaserVideoMeta:
      banquet.teaserVideoMeta && typeof banquet.teaserVideoMeta === "object" && !Array.isArray(banquet.teaserVideoMeta)
        ? banquet.teaserVideoMeta
        : base.teaserVideoMeta,
    foodCatering: banquet.foodCatering && typeof banquet.foodCatering === "object" && !Array.isArray(banquet.foodCatering) ? banquet.foodCatering : base.foodCatering,
    decorationServices:
      banquet.decorationServices && typeof banquet.decorationServices === "object" && !Array.isArray(banquet.decorationServices)
        ? banquet.decorationServices
        : base.decorationServices,
    alcoholPolicy:
      banquet.alcoholPolicy && typeof banquet.alcoholPolicy === "object" && !Array.isArray(banquet.alcoholPolicy)
        ? banquet.alcoholPolicy
        : banquet.policies?.liquorPolicy || banquet.alcoholPolicy
          ? { notes: banquet.policies?.liquorPolicy || banquet.alcoholPolicy }
          : base.alcoholPolicy,
    timingDetails: banquet.timingDetails && typeof banquet.timingDetails === "object" && !Array.isArray(banquet.timingDetails) ? banquet.timingDetails : base.timingDetails,
    parkingDetails: banquet.parkingDetails && typeof banquet.parkingDetails === "object" && !Array.isArray(banquet.parkingDetails) ? banquet.parkingDetails : base.parkingDetails,
    media: {
      ...base.media,
      ...(banquet.media || {}),
      coverPhotos: Array.isArray(banquet.media?.coverPhotos)
        ? banquet.media.coverPhotos
        : (banquet.coverImage ? [{ url: banquet.coverImage, name: "Primary cover", status: "uploaded" }] : []),
      galleryPhotos: Array.isArray(banquet.media?.galleryPhotos)
        ? banquet.media.galleryPhotos
        : Array.isArray(banquet.galleryImages)
          ? banquet.galleryImages.map((url) => ({ url, name: "Gallery photo", status: "uploaded" }))
          : Array.isArray(banquet.images)
            ? banquet.images.map((url) => ({ url, name: "Gallery photo", status: "uploaded" }))
            : base.media.galleryPhotos,
      videoTeasers: Array.isArray(banquet.media?.videoTeasers)
        ? banquet.media.videoTeasers
        : banquet.teaserVideoUrl
          ? [{ url: banquet.teaserVideoUrl, name: "Video teaser", status: "uploaded" }]
          : base.media.videoTeasers,
    },
    highlights: Array.isArray(banquet.highlights) ? banquet.highlights : base.highlights,
    packagesMenu: Array.isArray(banquet.packagesMenu) ? banquet.packagesMenu : base.packagesMenu,
    pricing: {
      ...base.pricing,
      ...(banquet.pricing || {}),
    },
    address: {
      ...base.address,
      ...(banquet.address || {}),
      pincode: banquet.address?.pincode || banquet.pincode || base.address.pincode,
      latitude: banquet.address?.latitude ?? banquet.latitude ?? base.address.latitude,
      longitude: banquet.address?.longitude ?? banquet.longitude ?? base.address.longitude,
    },
    pincode: banquet.pincode || banquet.address?.pincode || base.pincode,
    locality: banquet.locality || base.locality,
    area: banquet.area || base.area,
    city: banquet.city || base.city,
    shortDescription: banquet.shortDescription || base.shortDescription,
    description: banquet.description || base.description,
    guestRange: {
      ...base.guestRange,
      ...(banquet.guestRange || {}),
      min: banquet.guestRange?.min ?? banquet.guestMin ?? base.guestRange.min,
      max: banquet.guestRange?.max ?? banquet.guestMax ?? base.guestRange.max,
    },
    guestMin: banquet.guestMin ?? banquet.guestRange?.min ?? base.guestMin,
    guestMax: banquet.guestMax ?? banquet.guestRange?.max ?? base.guestMax,
    vegPrice: banquet.vegPrice ?? banquet.pricing?.vegPrice ?? base.vegPrice,
    nonVegPrice: banquet.nonVegPrice ?? banquet.pricing?.nonVegPrice ?? base.nonVegPrice,
    googleRating: banquet.googleRating ?? base.googleRating,
    googleRatingsTotal: banquet.googleRatingsTotal ?? base.googleRatingsTotal,
    googlePlaceId: banquet.googlePlaceId || base.googlePlaceId,
    website: banquet.website || base.website,
    openingHours: Array.isArray(banquet.openingHours) ? banquet.openingHours : base.openingHours,
    googlePhotos: Array.isArray(banquet.googlePhotos) ? banquet.googlePhotos : base.googlePhotos,
    venueType: banquet.venueType || base.venueType,
    featured: typeof banquet.featured === "boolean" ? banquet.featured : base.featured,
    mapUrl: banquet.mapUrl || base.mapUrl,
    googleMapsUrl: banquet.googleMapsUrl || banquet.mapUrl || base.googleMapsUrl,
    googleMapsEmbedUrl: banquet.googleMapsEmbedUrl || base.googleMapsEmbedUrl,
    latitude: banquet.latitude ?? banquet.address?.latitude ?? base.latitude,
    longitude: banquet.longitude ?? banquet.address?.longitude ?? base.longitude,
    facilities: Array.isArray(banquet.facilities) ? banquet.facilities : base.facilities,
    tags: Array.isArray(banquet.tags) ? banquet.tags : base.tags,
    eventTypes: Array.isArray(banquet.eventTypes) ? banquet.eventTypes : base.eventTypes,
    goodFor: Array.isArray(banquet.goodFor) ? banquet.goodFor : base.goodFor,
    notIdealFor: Array.isArray(banquet.notIdealFor) ? banquet.notIdealFor : base.notIdealFor,
    indoorOutdoor: Array.isArray(banquet.indoorOutdoor) ? banquet.indoorOutdoor : base.indoorOutdoor,
    foodType: banquet.foodType || base.foodType,
    floors: banquet.floors || banquet.floor || base.floors,
    parkingAvailable: typeof banquet.parkingAvailable === "boolean" ? banquet.parkingAvailable : base.parkingAvailable,
    parkingCapacity: banquet.parkingCapacity ?? base.parkingCapacity,
    valetParking: typeof banquet.valetParking === "boolean" ? banquet.valetParking : base.valetParking,
    roomsAvailable: typeof banquet.roomsAvailable === "boolean" ? banquet.roomsAvailable : base.roomsAvailable,
    roomCount: banquet.roomCount ?? base.roomCount,
    bridalRoom: typeof banquet.bridalRoom === "boolean" ? banquet.bridalRoom : base.bridalRoom,
    changingRoom: typeof banquet.changingRoom === "boolean" ? banquet.changingRoom : base.changingRoom,
    acHall: typeof banquet.acHall === "boolean" ? banquet.acHall : base.acHall,
    powerBackup: typeof banquet.powerBackup === "boolean" ? banquet.powerBackup : base.powerBackup,
    lift: typeof banquet.lift === "boolean" ? banquet.lift : base.lift,
    wheelchairFriendly: typeof banquet.wheelchairFriendly === "boolean" ? banquet.wheelchairFriendly : base.wheelchairFriendly,
    liquorAllowed: typeof banquet.liquorAllowed === "boolean" ? banquet.liquorAllowed : base.liquorAllowed,
    byobAllowed: typeof banquet.byobAllowed === "boolean" ? banquet.byobAllowed : base.byobAllowed,
    djAllowed: typeof banquet.djAllowed === "boolean" ? banquet.djAllowed : base.djAllowed,
    lateNightAllowed: typeof banquet.lateNightAllowed === "boolean" ? banquet.lateNightAllowed : base.lateNightAllowed,
    decorPolicy: banquet.decorPolicy || banquet.policies?.decorPolicy || base.decorPolicy,
    cateringPolicy: banquet.cateringPolicy || banquet.policies?.cateringPolicy || base.cateringPolicy,
    alcoholPolicyText:
      banquet.alcoholPolicyText ||
      (banquet.alcoholPolicy && typeof banquet.alcoholPolicy !== "object" ? banquet.alcoholPolicy : "") ||
      banquet.policies?.liquorPolicy ||
      base.alcoholPolicyText,
    outsideCateringAllowed: typeof banquet.outsideCateringAllowed === "boolean" ? banquet.outsideCateringAllowed : base.outsideCateringAllowed,
    outsideCateringPolicy: banquet.outsideCateringPolicy || base.outsideCateringPolicy,
    bookingPolicy: banquet.bookingPolicy || base.bookingPolicy,
    cancellationPolicy: banquet.cancellationPolicy || base.cancellationPolicy,
    paymentTerms: banquet.paymentTerms || base.paymentTerms,
    policies: {
      ...base.policies,
      ...(banquet.policies || {}),
    },
    availabilityCalendar: {
      ...base.availabilityCalendar,
      ...(banquet.availabilityCalendar || {}),
    },
    bookedSlots:
      banquet.bookedSlots && typeof banquet.bookedSlots === "object" && !Array.isArray(banquet.bookedSlots)
        ? banquet.bookedSlots
        : base.bookedSlots,
    bookedDates:
      banquet.bookedDates && typeof banquet.bookedDates === "object" && !Array.isArray(banquet.bookedDates)
        ? banquet.bookedDates
        : banquet.availabilityCalendar?.bookedDates && typeof banquet.availabilityCalendar.bookedDates === "object" && !Array.isArray(banquet.availabilityCalendar.bookedDates)
          ? banquet.availabilityCalendar.bookedDates
          : base.bookedDates,
    status: banquet.status || base.status,
    submittedForApproval: Boolean(banquet.submittedForApproval),
    submittedAt: banquet.submittedAt ?? base.submittedAt,
    approvedAt: banquet.approvedAt ?? base.approvedAt,
    rejectedAt: banquet.rejectedAt ?? base.rejectedAt,
    approvedBy: banquet.approvedBy || base.approvedBy,
    rejectionReason: banquet.rejectionReason || base.rejectionReason,
    ownerName: banquet.ownerName || base.ownerName,
    createdByOwner: Boolean(banquet.createdByOwner),
    createdBy: banquet.createdBy || base.createdBy,
    isActive: typeof banquet.isActive === "boolean" ? banquet.isActive : base.isActive,
    detailsLocked: typeof banquet.detailsLocked === "boolean" ? banquet.detailsLocked : base.detailsLocked,
    createdAt: banquet.createdAt ?? base.createdAt,
    updatedAt: banquet.updatedAt ?? base.updatedAt,
  };
};

export const banquetToFirestore = (banquet = {}) => {
  const normalized = normalizeBanquet(banquet);

  return {
    id: normalized.id,
    slug: normalized.slug,
    title: normalized.title,
    ownerId: normalized.ownerId,
    ownerEmail: normalized.ownerEmail,
    assignedUserIds: normalized.assignedUserIds,
    assignedUserEmails: normalized.assignedUserEmails,
    managerEmails: normalized.managerEmails,
    staffEmails: normalized.staffEmails,
    basicDetails: normalized.basicDetails,
    contactDetails: normalized.contactDetails,
    locationDetails: normalized.locationDetails,
    capacityDetails: normalized.capacityDetails,
    pricingDetails: normalized.pricingDetails,
    foodCatering: normalized.foodCatering,
    decorationServices: normalized.decorationServices,
    alcoholPolicy: normalized.alcoholPolicy,
    alcoholPolicyText: normalized.alcoholPolicyText,
    timingDetails: normalized.timingDetails,
    parkingDetails: normalized.parkingDetails,
    media: normalized.media,
    highlights: normalized.highlights,
    packagesMenu: normalized.packagesMenu,
    coverImage: normalized.coverImage,
    coverImageMeta: normalized.coverImageMeta,
    images: normalized.images,
    imageMetaByUrl: normalized.imageMetaByUrl,
    teaserVideoUrl: normalized.teaserVideoUrl,
    teaserVideoMeta: normalized.teaserVideoMeta,
    pricing: normalized.pricing,
    address: normalized.address,
    locality: normalized.locality,
    city: normalized.city,
    guestRange: normalized.guestRange,
    facilities: normalized.facilities,
    floors: normalized.floors,
    outsideCateringAllowed: normalized.outsideCateringAllowed,
    policies: normalized.policies,
    availabilityCalendar: normalized.availabilityCalendar,
    bookedSlots: normalized.bookedSlots,
    bookedDates: normalized.bookedDates,
    status: normalized.status,
    submittedForApproval: normalized.submittedForApproval,
    submittedAt: normalized.submittedAt,
    approvedAt: normalized.approvedAt,
    rejectedAt: normalized.rejectedAt,
    approvedBy: normalized.approvedBy,
    rejectionReason: normalized.rejectionReason,
    ownerName: normalized.ownerName,
    createdByOwner: normalized.createdByOwner,
    createdBy: normalized.createdBy,
    isActive: normalized.isActive,
    createdAt: normalized.createdAt,
    updatedAt: normalized.updatedAt,
  };
};
